export default {
  LINK_DEFAULT_VIEW_TYPE: state => state.linkDefaultViewType
};
